var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInformationButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_awesome-info-circle",
    "data-name": "Icon awesome-info-circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.588,
    height: 19.588,
    viewBox: "0 0 19.588 19.588",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-info-circle-2",
    "data-name": "Icon awesome-info-circle",
    d: "M10.357.563a9.794,9.794,0,1,0,9.794,9.794A9.8,9.8,0,0,0,10.357.563Zm0,4.344A1.659,1.659,0,1,1,8.7,6.565,1.659,1.659,0,0,1,10.357,4.907Zm2.212,10.031a.474.474,0,0,1-.474.474H8.619a.474.474,0,0,1-.474-.474V13.99a.474.474,0,0,1,.474-.474h.474V10.989H8.619a.474.474,0,0,1-.474-.474V9.567a.474.474,0,0,1,.474-.474h2.528a.474.474,0,0,1,.474.474v3.949h.474a.474.474,0,0,1,.474.474Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#3a484d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationButton);
export default __webpack_public_path__ + "static/media/information-button.28775d8a5b1e7bafc1de1c8e9f3679f2.svg";
export { ForwardRef as ReactComponent };